import { render, staticRenderFns } from "./ServiceCodeToothNumberAllowedAddEdit.vue?vue&type=template&id=1406e43e"
import script from "./ServiceCodeToothNumberAllowedAddEdit.vue?vue&type=script&lang=js"
export * from "./ServiceCodeToothNumberAllowedAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports